import { LitElement, html } from "lit-element";

export class DrawingModuleContainer extends LitElement {
	get MainTb() {
		return {
			value: this.moduleId,
			icon: this.icon,
			text: this.label
		};
	}

	Activate() {
		this.canvas.defaultCursor = "crosshair";

		if (!this.activeSubmodule)
			if (this.submodules.length > 0) {
				this.activeSubmodule = this.submodules[0];
				this.activeSubmodule.setAttribute("selected", "selected");
			}


		if (this.activeSubmodule)
			this.activeSubmodule.Activate();


		return this;
	}

	Deactivate() {
		if (this.activeSubmodule)
			this.activeSubmodule.Deactivate();

		this.canvas.setCursor(this.canvas.defaultCursor);
	}

	render() {
		return html` 
            <style>
                .shapes {
                    width: ${this.toolbarWidth};
                    margin-top: 5px;
                    display: flex;
                    flex-wrap: wrap;
                }

                *[selected] {
                    background-color: var(--primary-color);
                }
            </style>

            <div class="shapes">
                ${this.submodules}
            </div>`;
	}

	firstUpdated() {
		this.submodules.forEach(s => {
			s.addEventListener("click", () => {
				if (this.activeSubmodule && typeof this.activeSubmodule.Deactivate === 'function') {
					this.activeSubmodule.Deactivate();
				}
				
				if (typeof s.Activate !== 'function') return;

				this.activeSubmodule = s;
				s.Activate();

				let target = s;
				for (let element of target.parentElement.children) {
					element.removeAttribute("selected");
				}
				target.setAttribute("selected", "selected");
			});
		});
	}

	static get properties() {
		return {
			submodules: Array,
			activeSubmodule: Object
		};
	}

	constructor(canvas) {
		super();
		this.canvas = canvas;
		this.submodules = [];
	}
}
